// src/components/live-api/ConversationTimer.jsx
import React, {useState, useEffect, useRef} from 'react';

// Función para formatear el tiempo
const formatTime = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

const ConversationTimer = ({isStreaming}) => {
    const [elapsedTime, setElapsedTime] = useState(0);
    const timerIntervalRef = useRef(null);

    useEffect(() => {
        if (isStreaming) {
            setElapsedTime(0); // Reiniciar el tiempo cuando comienza el streaming
            timerIntervalRef.current = setInterval(() => {
                setElapsedTime(prevTime => prevTime + 1);
            }, 1000);
        } else {
            if (timerIntervalRef.current) {
                clearInterval(timerIntervalRef.current);
                timerIntervalRef.current = null;
            }
            // Opcional: resetear elapsedTime a 0 si quieres que se borre al detener
            // setElapsedTime(0);
        }

        return () => { // Limpieza del intervalo del temporizador
            if (timerIntervalRef.current) {
                clearInterval(timerIntervalRef.current);
            }
        };
    }, [isStreaming]);

    if (!isStreaming && elapsedTime === 0) { // No mostrar si no está streameando y el tiempo es 0
        return null;
    }

    // Si quieres que el timer permanezca visible con el último tiempo después de detener:
    // if (!isStreaming && elapsedTime > 0) {
    //     return (
    //         <div className="conversation-timer">
    //             {formatTime(elapsedTime)}
    //         </div>
    //     );
    // }
    // if (!isStreaming) return null; // O simplemente ocultarlo si no está streameando

    return (
        <div className="conversation-timer">
            {formatTime(elapsedTime)}
        </div>
    );
};

export default ConversationTimer;
